import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({ children }) => {

  const el = useRef(null);

  useEffect(() => {
    const root = document.getElementById('root');
    if (!root) return null;
    root.appendChild(el.current);
    return () => {
      root.removeChild(el.current);
      el.current = null;
    };
  }, []);
  if (typeof window === 'undefined') return null;

  if (!el.current) {
    el.current = document.createElement('div');
    el.current.id = 'media-portal';
  }

  return createPortal(children, el.current);
};

export default Portal;
